import { differenceInMinutes, fromUnixTime } from "date-fns";

import { API_URL } from "@/constants/envVariables";
import { SESSION_EXPIRED } from "@/constants/settings";

import { buildAuthHeaders, getAuthCredentials } from "@/helpers/authHeaders";
import { keycloakAuthState } from "@/helpers/keycloakAuthState";
import { parseJwt } from "@/helpers/parseJwt";

const MIN_MINUTES_FOR_REFRESH = 5;

export const refreshToken = async (token: string): Promise<string> => {
  // In Keycloak mode, Istio handles token management
  if (keycloakAuthState.isKeycloakMode) {
    return token;
  }

  const jwt = parseJwt(token);
  // JWT session is 15 min
  const minRemaining = differenceInMinutes(fromUnixTime(jwt.exp), Date.now());

  if (minRemaining <= 0) {
    throw SESSION_EXPIRED;
  } else if (minRemaining < MIN_MINUTES_FOR_REFRESH) {
    const response = await fetch(`${API_URL}/refresh-token`, {
      method: "POST",
      credentials: getAuthCredentials(),
      headers: {
        "Content-Type": "application/json",
        ...buildAuthHeaders(token),
      },
    });

    const responseJson = await response.json();

    if (responseJson.token) {
      return responseJson.token;
    }

    throw responseJson;
  }

  // Return current token
  return token;
};
